import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import ChatHistoryWidgetComponent from '@/shared/cards/my-create/ask-goover/chat-history-widget.vue';
import AskGooverService from '@/service/ask-goover.service';
import { ConversationInfo, HistoryChatResponse } from '@/shared/model/ask-goover.model';
import { convertDateToYYYYMMDD, convertToUtcISOString } from '@/util/date-util';
import ChatHistoryModalComponent from '@/shared/cards/my-create/ask-goover/chat-history-modal.vue';
import { v4 as uuidv4 } from 'uuid';
import bookmark from '@/v2/discovery/common/Bookmark.vue';
import NoData from '@/v2/discovery/NoData.vue';
import ListLoadingComponent from '@/entities/resource-management/list-loading/list-loading.vue';
import NoDataComponent from '@/v2/shared/my-create/no-data-component.vue';
import { MY_CREATE_TYPES } from '@/constants';

@Component({
  computed: {
    MY_CREATE_TYPES() {
      return MY_CREATE_TYPES;
    },
    bookmark() {
      return bookmark;
    },
  },
  components: {
    NoDataComponent,
    NoData,
    'chat-history-widget': ChatHistoryWidgetComponent,
    'chat-history-modal': ChatHistoryModalComponent,
    'list-loading': ListLoadingComponent,
  },
})
export default class MyCreateAskComponent extends Vue {
  @Inject('askGooverService')
  private askGooverService!: () => AskGooverService;
  tempUser = JSON.parse(localStorage.getItem('localStorageUser')) || {};

  widgetList: ConversationInfo[] = [];
  historyOpenModal = false;
  currentConversation = {};
  loadMoreAble = true;
  loading = false;
  isNoData = false;
  historyChatPagination = {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
  };

  mounted() {
    this.loadHistoryChat();
    $('#container-block').on('scroll', this.infinityScroll);
    this.$root.$on('update-conversation-title', this.updateConversationTitle);
  }

  beforeDestroy() {
    this.$root.$off('update-conversation-title', this.updateConversationTitle);
  }

  convertTitle(item: ConversationInfo) {
    try {
      if (item.briefingTitle) {
        return `${item.briefingTitle}`;
      } else {
        if (item.chatPage == 'home') {
          return this.$t('my-create.common.chat-page.home');
        }
        if (item.chatPage == 'browser') {
          return this.$t('my-create.common.chat-page.browser');
        }
        return item.chatPage.replace(/\b\w/g, char => char.toUpperCase()) + ' Page';
      }
    } catch (error) {
      console.log(error);
      return 'home';
    }
  }

  deactivated() {
    this.closeHistoryConversation();
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    if (to.path.includes('/my-create/ask-goover')) {
      this.widgetList = [];
      this.historyChatPagination = {
        currentPage: 0,
        pageSize: 50,
        totalItems: 0,
      };
      this.loadHistoryChat();
    }
  }

  deleteConversation(conversationId: string) {
    this.widgetList = this.widgetList.filter(item => item.conversationId !== conversationId);
    if (this.widgetList.length < 10) {
      this.loadHistoryChat();
    }
  }

  private showToast(message: string, title: string, variant = 'info'): void {
    this.$bvToast.toast(message, {
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: 5000,
      toaster: 'b-toaster-bottom-right',
      noCloseButton: false,
      appendToast: true,
    });
  }

  infinityScroll = () => {
    const container = $('#container-block').get(0);
    const scrollY = container.scrollHeight - container.scrollTop;
    const height = container.offsetHeight;
    const offset = height - scrollY;
    if (this.loadMoreAble && -2000 < offset) {
      this.onLoadMore();
    }
  };

  onLoadMore() {
    if (!this.loading && this.loadMoreAble) {
      this.historyChatPagination.currentPage++;
      this.loadHistoryChat();
    }
  }

  private loadHistoryChat() {
    const user = this.tempUser;
    const userKey = user.id;
    this.loading = true;
    this.loadMoreAble = false;
    const language = 'ALL';
    const pageIndex = this.historyChatPagination.currentPage;
    this.askGooverService()
      .getHistoryCreate(userKey, language, pageIndex)
      .then((response: HistoryChatResponse) => {
        const data = response.conversationInfos.map(item => ({
          ...item,
          historyDate: convertDateToYYYYMMDD(item.historyDate),
        }));
        this.widgetList = [...this.widgetList, ...data];
        this.historyChatPagination.totalItems = response.totalItems ?? 0;
        this.loadMoreAble = response.conversationInfos.length != 0;
        this.loading = false;
      })
      .catch(error => {
        console.error('Error loading history chat:', error);
        this.widgetList = [];
        this.loading = false;
        this.loadMoreAble = false;
      })
      .finally(() => {
        this.loading = false;
        if (this.widgetList.length == 0) {
          this.isNoData = true;
        } else {
          this.isNoData = false;
        }
      });
  }

  viewHistoryConversation(item: ConversationInfo) {
    this.currentConversation = item;
    this.historyOpenModal = true;
  }

  updateBookmark(model: ConversationInfo) {
    const user = this.tempUser;
    const userKey = user.id;
    const newBookmarkStatus = !model.isBookmark;
    const { isBookmark, title, ...otherInfo } = model;

    const payload = {
      userKey: userKey,
      conversationId: model.conversationId,
      title: title,
      login: userKey,
      isBookmark: newBookmarkStatus,
      otherInfo: otherInfo,
    };

    const index = this.widgetList.findIndex(item => item.conversationId === model.conversationId);

    if (index !== -1) {
      this.$set(this.widgetList, index, {
        ...this.widgetList[index],
        isBookmark: newBookmarkStatus,
      });
    }
    this.askGooverService()
      .addBookMark(payload)
      .then(resp => {
        const index = this.widgetList.findIndex(item => item.conversationId === model.conversationId);
        if (index !== -1) {
          this.$set(this.widgetList, index, {
            ...this.widgetList[index],
            isBookmark: newBookmarkStatus,
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  navigateChat(chatPage: 'home' | 'briefing', conversationId: string) {
    switch (chatPage) {
      case 'home': {
        this.$router.push({ path: '/home', query: { conversationId } });
        return;
      }
      case 'briefing': {
        const briefingId = conversationId.split(':')[1];
        this.$router.push({ path: '/my-briefing/' + briefingId });
        return;
      }
      default: {
        this.$router.push({ path: '/home', query: { conversationId } });
        return;
      }
    }
  }

  copyShareLink(conversationId: any) {
    const url = `${window.location.origin}/home?conversationId=${conversationId}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        this.showToast(this.$t('my-create.common.share.coppy') as string, this.$t('my-create.common.share.success') as string, 'success');
      })
      .catch(() => {
        this.showToast('Cannot coppied to clipboard.', 'Fail', 'danger');
      });
  }

  closeHistoryConversation() {
    this.historyOpenModal = false;
    // this.widgetList = [];
  }

  private totalPagesHistoryChat() {
    const { pageSize, totalItems } = this.historyChatPagination;
    return Math.ceil(totalItems / pageSize) || 1;
  }

  updateConversationTitle(newTitle: string) {
    this.widgetList.forEach(item => {
      // @ts-ignore
      if (item.conversationId === this.currentConversation.conversationId) {
        item.title = newTitle;
      }
    });
  }
}
